function showSuccess(successBox, errorBox, message) {
  if (!successBox || !errorBox) return;
  successBox.classList.remove('hidden');
  errorBox.classList.add('hidden');
  successBox.textContent = message;
}

function showError(successBox, errorBox, message) {
  if (!successBox || !errorBox) return;
  errorBox.classList.remove('hidden');
  successBox.classList.add('hidden');
  errorBox.textContent = message;
}

function queryParam(name) {
  const url = new URL(window.location.href);
  return url.searchParams.get(name);
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

function getGaClientIdIfAllowed(consentAnalytics) {
  if (!consentAnalytics) return null;
  const ga = getCookie('_ga');
  if (!ga) return null;
  const parts = ga.split('.');
  if (parts.length < 4) return null;
  return parts.slice(-2).join('.');
}

function loadConsentApi() {
  return new Promise((resolve) => {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      resolve(window.Shopify.customerPrivacy);
      return;
    }

    if (!window.Shopify || !window.Shopify.loadFeatures) {
      resolve(null);
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function(error) {
        if (error || !window.Shopify.customerPrivacy) {
          resolve(null);
          return;
        }
        resolve(window.Shopify.customerPrivacy);
      }
    );
  });
}

async function buildPayload(form) {
  const fd = new FormData(form);
  const customerPrivacy = await loadConsentApi();

  const consentAnalytics = customerPrivacy?.analyticsProcessingAllowed?.() ?? null;
  const consentMarketing = customerPrivacy?.marketingAllowed?.() ?? null;
  const consentPreferences = customerPrivacy?.preferencesProcessingAllowed?.() ?? null;
  const consentSaleOfData = customerPrivacy?.saleOfDataAllowed?.() ?? null;
  const shopifyConsentId = customerPrivacy?.consentId?.() ?? null;

  return {
    email: fd.get('email'),
    firstName: fd.get('firstName'),
    lastName: fd.get('lastName'),
    phone: fd.get('phone'),
    state: fd.get('state'),
    marketingOptIn: fd.get('marketingOptIn') === 'true',
    smsOptIn: fd.get('smsOptIn') === 'true',
    pageUrl: window.location.href,
    pagePath: window.location.pathname,
    pageTitle: document.title,
    pageHandle: form.dataset.pageHandle || null,
    shopDomain: form.dataset.shopDomain || null,
    referrerUrl: document.referrer || null,
    utmSource: queryParam('utm_source'),
    utmMedium: queryParam('utm_medium'),
    utmCampaign: queryParam('utm_campaign'),
    utmContent: queryParam('utm_content'),
    utmTerm: queryParam('utm_term'),
    gclid: queryParam('gclid'),
    fbclid: queryParam('fbclid'),
    msclkid: queryParam('msclkid'),
    ttclid: queryParam('ttclid'),
    gaClientId: getGaClientIdIfAllowed(consentAnalytics),
    consentAnalytics,
    consentMarketing,
    consentPreferences,
    consentSaleOfData,
    shopifyConsentId,
    shopifyLoggedInCustomerId: form.dataset.loggedInCustomerId || null,
    landingTimestamp: new Date().toISOString(),
    language: navigator.language || null,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || null
  };
}

async function handleReferrerSignup(event, form, successBox, errorBox, submitButton) {
  event.preventDefault();

  successBox.classList.add('hidden');
  errorBox.classList.add('hidden');

  const submitLabel = submitButton.querySelector('.button__content') || submitButton;
  const originalLabel = submitLabel.innerHTML;
  const loadingLabel = form.dataset.loadingLabel || 'Sending...';

  try {
    submitButton.disabled = true;
    submitLabel.innerHTML = loadingLabel;

    const payload = await buildPayload(form);
      
    let apiBase = (form.dataset.apiBase || 'https://api.driveready.co').replace(/\/$/, '');
    if (window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost') {
      apiBase = "http://127.0.0.1:5173";
    }
    
    let apiPath = form.dataset.shopPath || '/api/v1/partner/create/page';

    const endpoint = apiBase + apiPath;
    
    debugger;
    console.log("endpoint for lead submit is: ", endpoint);

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    const result = await response.json();

    if (!response.ok || !result.ok) {
      throw new Error(result.error || form.dataset.errorMessage || 'Unable to submit your request right now.');
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'dr_referrer_signup_submitted',
      event_category: 'referrer_program',
      lead_type: 'referrer_signup',
      page_handle: payload.pageHandle || 'refer',
      marketing_opt_in: payload.marketingOptIn,
      utm_source: payload.utmSource || '(direct)',
      utm_medium: payload.utmMedium || '(none)'
    });

    showSuccess(
      successBox,
      errorBox,
      form.dataset.successMessage || 'Success! Check your inbox for your secure sign-in link.'
    );
    form.reset();
  } catch (error) {
    showError(
      successBox,
      errorBox,
      error && error.message ? error.message : (form.dataset.errorMessage || 'Something went wrong.')
    );
  } finally {
    submitButton.disabled = false;
    submitLabel.innerHTML = originalLabel;
  }
}

function initReferrerForms(root) {
  const scope = root || document;
  const forms = scope.querySelectorAll('form[id^="ReferrerLeadForm-"]');

  forms.forEach((form) => {
    if (form.dataset.bound === 'true') return;
    form.dataset.bound = 'true';

    const successBox = form.querySelector('.dr-status-success');
    const errorBox = form.querySelector('.dr-status-error');
    const submitButton = form.querySelector('.dr-submit-btn');

    if (!submitButton) return;

    form.addEventListener('submit', function(event) {
      handleReferrerSignup(event, form, successBox, errorBox, submitButton);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initReferrerForms(document);
  });
} else {
  initReferrerForms(document);
}

document.addEventListener('shopify:section:load', function(event) {
  if (event.target && event.target.classList.contains('shopify-section')) {
    initReferrerForms(event.target);
  }
});